import LoadingButton from "@/components/loading-button";

import { Alert, AlertDescription } from "@/components/ui/alert";

export default function ResendEmailAlert({ resendLoading, handleResendVerification }: { resendLoading: boolean, handleResendVerification: () => void }) {
    return (
        <Alert variant="default" className=" border-primary/20 bg-primary/5 text-primary">
            <div className="flex flex-col space-y-3">
                <AlertDescription className="font-medium">
                    Your email address needs to be verified before you can proceed.
                </AlertDescription>
                <LoadingButton
                    variant="outline"
                    size="sm"
                    loading={resendLoading}
                    loadingText="Sending verification email..."
                    className="w-fit"
                    onClick={handleResendVerification}
                >
                    Resend Verification Email
                </LoadingButton>
            </div>
        </Alert>
    )
}

